import React, { Component } from 'react';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Footer from './components/common/footer';
import Header from './components/common/headerIndex';
import Routes from './routes/routes';

class App extends Component {

  render() {
    return (
      <ThemeProvider theme={theme}>
        <React.Fragment>
          <Header/>
          <Routes/> 
          <Footer/>
        </React.Fragment>
      </ThemeProvider>
    );
  }
}

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Noto Serif JP',
      'serif',
    ].join(','),
  },});

export default App;
